"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOUR_SCALES = exports.STATE_ABBREVS = exports.STATE_CODES = exports.CHART_TYPES = exports.ADJUSTMENT_STRINGS = exports.THROTTLE = exports.TOP_USA_NAME = exports.API_METRICS_BASE = exports.SOTU_METRIC_BASE = void 0;
exports.SOTU_METRIC_BASE = 'https://sotu.usafacts.org/api/v1/metrics';
exports.API_METRICS_BASE = 'https://a.usafacts.org/api/v4/Metrics';
exports.TOP_USA_NAME = 'USA';
exports.THROTTLE = 1000 / 60;
exports.ADJUSTMENT_STRINGS = {
  PerCapita: 'Adjusted per capita',
  Inflation: 'Adjusted for inflation'
};
exports.CHART_TYPES = {
  LineChart: 0,
  Map: 1,
  DotPlot: 2,
  BarChart: 3,
  SmallMultiples: 4,
  BubbleChart: 5,
  Sankey: 6,
  IncomeDistribution: 7,
  TimeBarChart: 9,
  Beeswarm: 10,
  MosaicPlot: 11,
  SankeyVertical: 12,
  SOTU2021Education: 13,
  GroupedBars: 14,
  LineChartReactMigration: 100,
  MapReactMigration: 101,
  DotPlotReactMigration: 102,
  BarChartReactMigration: 103,
  LineChartReact: 200,
  MapReact: 201,
  DotPlotReact: 202,
  BarChartReact: 203,
  TimeSeriesBarChart: 209,
  CartogramReact: 215
};
exports.STATE_CODES = {
  US: 'United States',
  '01': 'Alabama',
  '02': 'Alaska',
  '04': 'Arizona',
  '05': 'Arkansas',
  '06': 'California',
  '08': 'Colorado',
  '09': 'Connecticut',
  10: 'Delaware',
  11: 'District of Columbia',
  12: 'Florida',
  13: 'Georgia',
  15: 'Hawaii',
  16: 'Idaho',
  17: 'Illinois',
  18: 'Indiana',
  19: 'Iowa',
  20: 'Kansas',
  21: 'Kentucky',
  22: 'Louisiana',
  23: 'Maine',
  24: 'Maryland',
  25: 'Massachusetts',
  26: 'Michigan',
  27: 'Minnesota',
  28: 'Mississippi',
  29: 'Missouri',
  30: 'Montana',
  31: 'Nebraska',
  32: 'Nevada',
  33: 'New Hampshire',
  34: 'New Jersey',
  35: 'New Mexico',
  36: 'New York',
  37: 'North Carolina',
  38: 'North Dakota',
  39: 'Ohio',
  40: 'Oklahoma',
  41: 'Oregon',
  42: 'Pennsylvania',
  44: 'Rhode Island',
  45: 'South Carolina',
  46: 'South Dakota',
  47: 'Tennessee',
  48: 'Texas',
  49: 'Utah',
  50: 'Vermont',
  51: 'Virginia',
  53: 'Washington',
  54: 'West Virginia',
  55: 'Wisconsin',
  56: 'Wyoming'
};
exports.STATE_ABBREVS = {
  'United States': 'US',
  Alabama: 'AL',
  Alaska: 'AK',
  Arkansas: 'AR',
  Arizona: 'AZ',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  'District of Columbia': 'DC',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Iowa: 'IA',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Massachusetts: 'MA',
  Maryland: 'MD',
  Maine: 'ME',
  Michigan: 'MI',
  Minnesota: 'MN',
  Missouri: 'MO',
  Mississippi: 'MS',
  Montana: 'MT',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Nebraska: 'NE',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  Nevada: 'NV',
  'New York': 'NY',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Virginia: 'VA',
  Vermont: 'VT',
  Washington: 'WA',
  Wisconsin: 'WI',
  'West Virginia': 'WV',
  Wyoming: 'WY'
};
exports.COLOUR_SCALES = {
  sequentialYellowGreen: ['#E6F1A3', '#8DDEAA', '#42C4A2', '#109D7B', '#007358', '#004837'],
  sequentialMagentaPurple: ['#E8D7FA', '#E39DDC', '#DE5BBA', '#BB1C91', '#6F1B7C', '#091A60'],
  sequentialYellowBlue: ['#E0EB9D', '#67D7B5', '#00B5DA', '#067EC2', '#004288', '#05074B'],
  sequentialPurpleGreen: ['#A5C8FF', '#56C3EA', '#04B8BC', '#00909A', '#004D7C', '#02093C'],
  divergingYellowGreen: ['#CC6A19', '#D99522', '#E5BD3F', '#F2E289', '#97DFC7', '#65C2A5', '#00664E', '#012B2D'],
  divergingPurpleGreen: ['#461B71', '#7E589F', '#B697CE', '#F0DBFF', '#97DFC7', '#65C2A5', '#00664E', '#012B2D'],
  divergingMagentaBlue: ['#A7004C', '#F2618B', '#F1D1DA', '#B8DAEB', '#1E8CC8', '#043D70']
};